import { render, staticRenderFns } from "./withdrawalDetail.vue?vue&type=template&id=713b0237&scoped=true&"
import script from "./withdrawalDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawalDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalDetail.vue?vue&type=style&index=0&id=713b0237&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b0237",
  null
  
)

export default component.exports